import { formatExportRequestCount } from './format-export-request-count.js';

export function buildExportConfirmMessage(totalCount: number): string {
  return `Exporting ${totalCount.toLocaleString()} rows takes ${formatExportRequestCount(totalCount)} requests and may take a while. Export anyway?`;
}
